"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PatientEmployerRelationsDetails = _interopRequireDefault(require("./PatientEmployerRelationsDetails"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _PatientEmployerRelationsDetails.default;
exports.default = _default;